import { render, staticRenderFns } from "./SignupLayout.vue?vue&type=template&id=204e3c32&scoped=true&"
import script from "./SignupLayout.vue?vue&type=script&lang=js&"
export * from "./SignupLayout.vue?vue&type=script&lang=js&"
import style0 from "./SignupLayout.vue?vue&type=style&index=0&id=204e3c32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204e3c32",
  null
  
)

export default component.exports